import { Box } from '@mui/material';
import React from 'react';

const previewShellSx = {
  p: 1.5,
  display: 'flex',
  justifyContent: 'center',
} as const;

interface ChatLinkPreviewShellProps {
  children: React.ReactNode;
}

/** Shared popover padding for chat link previews — cards supply their own kanban hover actions. */
const ChatLinkPreviewShell: React.FC<ChatLinkPreviewShellProps> = ({ children }) => (
  <Box sx={previewShellSx}>{children}</Box>
);

export default ChatLinkPreviewShell;
